/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Observable} from 'rxjs/Observable';
import {AbstractControl} from '../model';
import {ValidationErrors} from './validators';
/**
 * Base class for control directives.
 * 
 * Only used internally in the forms module.
 * 
 * \@stable
 * @abstract
 */
export abstract class AbstractControlDirective {
/**
 * @abstract
 * @return {?}
 */
control() {}
/**
 * @return {?}
 */
get value(): any { return this.control ? this.control.value : null; }
/**
 * @return {?}
 */
get valid(): boolean|null { return this.control ? this.control.valid : null; }
/**
 * @return {?}
 */
get invalid(): boolean|null { return this.control ? this.control.invalid : null; }
/**
 * @return {?}
 */
get pending(): boolean|null { return this.control ? this.control.pending : null; }
/**
 * @return {?}
 */
get errors(): ValidationErrors|null { return this.control ? this.control.errors : null; }
/**
 * @return {?}
 */
get pristine(): boolean|null { return this.control ? this.control.pristine : null; }
/**
 * @return {?}
 */
get dirty(): boolean|null { return this.control ? this.control.dirty : null; }
/**
 * @return {?}
 */
get touched(): boolean|null { return this.control ? this.control.touched : null; }
/**
 * @return {?}
 */
get untouched(): boolean|null { return this.control ? this.control.untouched : null; }
/**
 * @return {?}
 */
get disabled(): boolean|null { return this.control ? this.control.disabled : null; }
/**
 * @return {?}
 */
get enabled(): boolean|null { return this.control ? this.control.enabled : null; }
/**
 * @return {?}
 */
get statusChanges(): Observable<any>|null {
    return this.control ? this.control.statusChanges : null;
  }
/**
 * @return {?}
 */
get valueChanges(): Observable<any>|null {
    return this.control ? this.control.valueChanges : null;
  }
/**
 * @return {?}
 */
get path(): string[]|null { return null; }
/**
 * @param {?=} value
 * @return {?}
 */
reset(value: any = undefined): void {
    if (this.control) this.control.reset(value);
  }
/**
 * @param {?} errorCode
 * @param {?=} path
 * @return {?}
 */
hasError(errorCode: string, path?: string[]): boolean {
    return this.control ? this.control.hasError(errorCode, path) : false;
  }
/**
 * @param {?} errorCode
 * @param {?=} path
 * @return {?}
 */
getError(errorCode: string, path?: string[]): any {
    return this.control ? this.control.getError(errorCode, path) : null;
  }
}
